document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('cstm-tog-selector-container-size-chart-trigger');
  var popup = document.getElementById('cstm-tog-selector-container-size-chart-popup');
  var closeBtn = document.getElementById('cstm-tog-selector-container-close-popup');

  if (!trigger || !popup || !closeBtn) return;

  function openPopup() {
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
  
    // 🔥 force recalculation AFTER render
    requestAnimationFrame(() => {
      setPopupBelowHeader();
    });
  }

  function closePopup() {
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    openPopup();
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });
});